<ng-container [ngTemplateOutlet]="content"></ng-container>

<ng-template #content>
  <div class="cc-shell">

    <!-- Header -->
    <div class="cc-header">
      <div class="cc-title-group">
        <span nz-icon nzType="line-chart" class="cc-title-icon"></span>
        <span class="cc-title">{{ item.title }}</span>
      </div>

      <button nz-button nzType="text" nzShape="circle" *ngIf="showConfiguration"
        nz-dropdown [nzDropdownMenu]="menu" nzTrigger="click">
        <span nz-icon nzType="more"></span>
      </button>

      <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul nz-menu>
          <li nz-menu-item (click)="openConfiguration()">
            <span nz-icon nzType="setting" class="cc-menu-icon"></span>
            <span>Configurações</span>
          </li>
          <li nz-menu-item nzDanger (click)="excluir()">
            <span nz-icon nzType="delete" class="cc-menu-icon"></span>
            <span>Excluir</span>
          </li>
        </ul>
      </nz-dropdown-menu>
    </div>

    <!-- Chart -->
    <div class="cc-chart-wrapper">
      <button nz-button nzType="text" nzShape="circle"
        class="cc-expand-btn"
        (click)="openOverlay()"
        nz-tooltip [nzTooltipTitle]="expand ? 'Fechar' : 'Expandir'">
        <span nz-icon [nzType]="expand ? 'fullscreen-exit' : 'fullscreen'"></span>
      </button>

      <nz-spin class="cc-spin" [nzSpinning]="loading" nzSize="large">
        <ag-charts *ngIf="chartOptions != null"
          class="cc-chart-body"
          [options]="chartOptions">
        </ag-charts>
      </nz-spin>
    </div>

    <!-- Footer -->
    <div class="cc-footer" *ngIf="item.refresh != null && item.refresh > 0">
      <span class="cc-last-update">
        <span nz-icon nzType="clock-circle" class="cc-last-update-icon"></span>
        Última Atualização: {{ lastUpdate }}
      </span>
    </div>
  </div>
</ng-template>
